/**
 * AI Model Configuration
 * 
 * Centralized model names for consistency across the application
 */

export const OPENAI_MODELS = {
  GPT_4_1: 'gpt-4.1',
  GPT_4_1_MINI: 'gpt-4.1-mini',
  GPT_4_1_NANO: 'gpt-4.1-nano',
  GPT_4O: 'gpt-4o',
  GPT_4O_MINI: 'gpt-4o-mini',
} as const;

export const GEMINI_MODELS = {
  // Gemini 2.5 series
  GEMINI_2_5_PRO: 'gemini-2.5-pro',
  GEMINI_2_5_FLASH: 'gemini-2.5-flash',
  GEMINI_2_5_FLASH_LITE: 'gemini-2.5-flash-lite',
  // Gemini 2.0 series
  GEMINI_2_FLASH: 'gemini-2.0-flash',
  GEMINI_2_FLASH_LITE: 'gemini-2.0-flash-lite',
  // Gemini 1.5 series (stable)
  GEMINI_1_5_PRO: 'gemini-1.5-pro',
  GEMINI_1_5_FLASH: 'gemini-1.5-flash',
} as const;

/**
 * Default model recommendations by use case
 */
export const DEFAULT_MODELS = {
  // Chat and general AI agent
  CHAT: {
    openai: OPENAI_MODELS.GPT_4_1_MINI,
    gemini: GEMINI_MODELS.GEMINI_2_5_FLASH,
  },
  // Translation tasks
  TRANSLATION: {
    openai: OPENAI_MODELS.GPT_4_1_MINI,
    gemini: GEMINI_MODELS.GEMINI_2_5_FLASH,
  },
  // Executive summaries and analysis
  ANALYSIS: {
    openai: OPENAI_MODELS.GPT_4_1_MINI,
    gemini: GEMINI_MODELS.GEMINI_2_5_PRO,
  },
  // Document parsing
  PARSING: {
    openai: OPENAI_MODELS.GPT_4_1_MINI,
    gemini: GEMINI_MODELS.GEMINI_2_5_PRO,
  },
  // Quiz generation (flashcard-style questions)
  QUIZ: {
    openai: OPENAI_MODELS.GPT_4_1_MINI,
    gemini: GEMINI_MODELS.GEMINI_2_5_FLASH,
  },
} as const;

/**
 * Get the recommended model for a given provider and use case
 */
export function getRecommendedModel(
  provider: 'openai' | 'gemini',
  useCase: keyof typeof DEFAULT_MODELS = 'CHAT'
): string {
  return DEFAULT_MODELS[useCase][provider];
}

